import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppService } from 'src/app/core/services/app.service';

export interface LoginRequest {
  username?: string;
  password: string;
}

export interface DigitalAuthRequest {
  cookie: string;
}
export interface DigitalAuthResponse {
 Data: any;
 IsSuccess: boolean;
 Message: string;
 StatusCode: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private digitalAuthUrl = `${AppService.getApiUrl()}/api/customers/digitalAuth/login`;
  
  constructor(
    private http: HttpClient,
  ) {
  }


  login(credentials: LoginRequest) {
    return this.http.post<DigitalAuthResponse>(this.digitalAuthUrl, credentials, {
      observe: 'response',
      withCredentials: true
    }).pipe(
      map((response: HttpResponse<DigitalAuthResponse>) => {
        return response.body;
      })
    );
  }
}